export enum TiposRolesEnum {
    Administrador = 1,
    Supervisor = 2    ,
    Ejecutivo = 3
}
